import { Component, Input, OnInit, OnDestroy, ViewChild, NgZone, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ShoppingCenter, Space, Store } from '../../../core/models';
import { SpinnerSize } from '../../../core/util/spinner/spinner-size.enum';
import { catchError, filter, finalize, switchMap, tap, takeUntil } from 'rxjs/operators';
import { StoreService } from '../../../core/store/store.service';
import { DefinitionType } from '../../../core/definition/definition-type.enum';
import { DefinitionViewComponent } from '../../../core/definition/definition-display/definition-view.component';
import { forkJoin, Observable, of, Subject, throwError } from 'rxjs';
import { DatePipe } from '@angular/common';
import { InsightsDatePipe } from '../../../core/date/insights-date.pipe';
import { SpaceService } from '../../../core/space/space.service';
import * as _ from 'lodash';
import { AuthorizationAwareComponent } from '../../../core/authorization-aware-component';
import { AppState } from '../../../app-state';
import { Store as NgrxStore } from '@ngrx/store';
import { LicenseType } from '../../../auth/authorization/license-type.enum';
import { FutureStoreStatuses, HistoricalStoreStatuses, StoreStatusType } from '../../../core/identity/constant/store-status-type.enum';
import { MtnMap } from '../../../map/mtn-map';
import { MapEvent, MapEventType, MapSelectionEvent } from '../../../map/map-events';
import { StoreVolume } from '../../../core/store/volume/store-volume';
import { Router } from '@angular/router';
import { OverallGradeBreakdownHeaderComponent } from '../overall-grade-breakdown-header/overall-grade-breakdown-header.component';
import { HitTrackingService } from 'src/app/core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';
import { MapSelectionMode } from 'src/app/map/map-selection-mode.enum';
import { GradeViewStateService } from '../asset-grade-card/grade-view-state.service';
import { AssetReviewService } from '../asset-review/asset-review.service';
import { ShapeService } from 'src/app/core/depot/shape.service';
import { SearchIntersectingShapeRequest } from 'src/app/core/depot/search-intersecting-shape-request';
import { SpatialShapeType } from 'src/app/core/depot/spatial-shape-type.enum';
import { DetailState, selectDetailState } from 'src/app/detail/detail-state';
import { toAnalyticsPanelInputs } from '../asset-review/grade-record.adapter';
import { StoreGradeRecord, StoreGradeResponse } from '../asset-review/store-grade.model';




interface StorePerformanceData {
  salesTotalPerformance: {
    vsTradeAreaSalesAverage: number;
    vsBannerMarketSalesAverage: number;
    vsMarketSalesAverage: number;
    annualSalesTotal: number;
    salesTotalGrade: string;
    salesIndexScore: number;
  };
  salesPerSqftPerformance: {
    vsTradeAreaSalesPerSqftAverage: number;
    vsBannerMarketSalesPerSqftAverage: number;
    vsMarketSalesPerSqftAverage: number;
    annualSalesPerSqft: number;
    salesPerSqftGrade: string;
    salesPerSqftIndexScore: number;
  };
  driveTimeMinutes : number;
}

@Component({
  standalone: false,
  selector: 'mtn-store-spotlight-panel',
  templateUrl: './store-spotlight-panel.component.html',
  styleUrls: ['../spotlight-panel.scss', './store-spotlight-panel.component.scss'],
  providers: [DatePipe, InsightsDatePipe, OverallGradeBreakdownHeaderComponent]
})
export class StoreSpotlightPanelComponent extends AuthorizationAwareComponent implements OnInit, OnDestroy {

  @Input()
  map: MtnMap;

  assetReview = false;
  cbsa: String;

  @ViewChild('shoppingCenterType')
  definitionShoppingCenterType: DefinitionViewComponent;

  // Destroy subject for managing subscriptions
  private destroy$ = new Subject<void>();
  private currentStoreLoadDestroy$ = new Subject<void>();
  private analyticsDestroy$ = new Subject<void>();

  storePerformanceData: StorePerformanceData;
  DefinitionType = DefinitionType;
  isFailed = false;
  isFutureStore = false;
  isHistoricalStore = false;
  isLoading = false;
  isVisible = true;
  otherStores: Store[] = [];
  salesAreaPercentage: number;
  shoppingCenter: ShoppingCenter;
  space: Space;
  SpinnerSize = SpinnerSize;
  store: Store;
  volume: StoreVolume;
  uuidc: string;
  banneruuid: string;
  point: any = {};
  isExpandedView = false;
  dataValidation = false;
  assetReviewDropdown = true;
  loadingdataValidation = 0;
  @Output() expandRequested = new EventEmitter<void>();
private progressInterval: any; // or NodeJS.Timeout if strict typing

  assetReviewStoreDetails: any = {};
  assetReviewRealEstateQuality: any = {};
  /** The stored record the breakdown is showing, when it came from the grade API. */
  gradeRecord: StoreGradeRecord | null = null;
  bannerStrengthData: any = {};
  gradeBreakdownData: any = {};
  competitiveImpactData: any = {};
  analyticsData: any = {};
  // Loading states for analytics
  isAnalyticsLoading = false;
  isAnalyticsDataLoading = false;
  analyticsLoadingProgress = 0;
  analyticsApiCount = 0;
  totalAnalyticsApis = 6; // 6 APIs: store details, real estate, banner strength, store performance, competitive impact, final grade
  hasAnalyticsError = false;
  apiCompletionStatus = {
    storeDetails: false,
    realEstate: false,
    bannerStrength: false,
    storePerformance: false,
    competitiveImpact: false,
    finalGrade: false
  };
  apiFailureStatus = {
    storeDetails: false,
    realEstate: false,
    bannerStrength: false,
    storePerformance: false,
    competitiveImpact: false,
    finalGrade: false
  };

  @Output() analyticsActiveChange = new EventEmitter<boolean>();

  handleExpand() {
    this.expandRequested.emit();
    this.isExpandedView = !this.isExpandedView;
  }

  otherstoreData = {};
  private uuid: string;
  private fips: string;
  private geometry: any;
  marketName: any;

  totalSalesPerformance: any = {
    icon: 'assets/images/bar-chart-square-02.png',
    name: "Total Sales Performance",
    grade: "A-",
    data: {
      "vs Trade Area Average": "-1.5%",
      "vs Banner Market Average": "+8.3%",
      "vs Banner Average": "+15.7%%",
    },
    result: {
      "Annual Sales": "$24.8M"
    }
  }

  SalesPerSQFT: any = {
    icon: 'assets/images/line-chart-down-04.png',
    name: "Sales Per Square Foot",
    grade: "B",
    data: {
      "vs Trade Area Average": "+6.8%",
      "vs Banner Market Average": "-2.1%",
      "vs Banner Average": "+15.7%",
    },
    result: {
      "Annual Sales": "$24.8M"
    }
  }

  realEstateQuality: any = {
    icon: 'assets/images/building-01.png',
    name: "Real Estate Quality ",
    grade: "A",
    data: {
      "Access": "+6.8%",
      "Parking": "-2.1%",
      "Visibility": "+15.7%",
      "Traffic Flow": "High",
      "SC Condition": "High",
    }
  }

  bannerStrength: any = {
    icon: 'assets/images/target-05.png',
    name: "Banner Strength",
    grade: "A",
    data: {
      "Credit Score": "A1 - Excellent",
      "Network Stability": "Moderately Stable",
      "Market Presence": "Low"
    }
  }

  competitiveImpact: any = {
    icon: 'assets/images/bar-chart-square-01.png',
    name: "Competitive Impact",
    grade: "A+",
    data: {
      "Costco Wholesale": "1.4 m",
      "Target": "1.8 m",
      "Whole foods Market Presence": "2.1 m",
      "Walmart Supercenter": "2.2 m",
      "Dollar General": "4.7 m",
      "CVS Pharmacy": "5.0 m"
    }
  }

  constructor(
    protected ngrxStore: NgrxStore<AppState>,
    private spaceService: SpaceService,
    private storeService: StoreService,
    private NgZone: NgZone,
    private cdr: ChangeDetectorRef,
    private hitTrackingService: HitTrackingService,
    private router: Router,
    private assetReviewService: AssetReviewService,
    private gradeViewState: GradeViewStateService,
    private shapeService: ShapeService
  ) {
    super(ngrxStore);
    this.subscribeToDetailState();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
  // Complete destroy subjects
  this.destroy$.next();
  this.destroy$.complete();

  this.currentStoreLoadDestroy$.next();
  this.currentStoreLoadDestroy$.complete();

  this.analyticsDestroy$.next();
  this.analyticsDestroy$.complete();



  // Stop any running progress simulation
  if (this.progressInterval) {
    clearInterval(this.progressInterval);
    this.progressInterval = null;
  }
}

   private subscribeToDetailState(): void {
      this.addSubscription(
        selectDetailState(this.ngrxStore)
          .subscribe((state: DetailState) => {
            const feature = state.marketArea?.getFeature();
            if (feature) {
              this.marketName = feature.properties['name'];
            }
          })
      );
    }


  openAssetReview() {
    this.router.navigate(['/detail/asset-review', this.store.uuid]);
  }

  handleAssetReview(value: boolean,source: 'try-now' | 'actions-dropdown') {
    console.log('Received from child:', value,source);
    this.analyticsActiveChange.emit(value);
    this.assetReview = value;

    if (value) {
      // Reset ALL states and clear store details to prevent showing previous store data
      this.hasAnalyticsError = false;
      this.dataValidation = false;
      this.loadingdataValidation = 0;
      this.isAnalyticsLoading = false;
      this.isAnalyticsDataLoading = false;
      this.analyticsLoadingProgress = 0;
      this.assetReviewStoreDetails = {};

      // Reset API completion status
      this.apiCompletionStatus = {
        storeDetails: false,
        realEstate: false,
        bannerStrength: false,
        storePerformance: false,
        competitiveImpact: false,
        finalGrade: false
      };

      // Clear FIPS and geometry to force fresh calls
      this.fips = null;
      this.geometry = null;

      this.loadStoredGrade(source);
    }
  }

  /**
   * Opens the breakdown from the stored grade rather than recalculating it.
   *
   * The docked panel, the expanded panel and the asset review page all read this same record,
   * so the grade shown in the breakdown always matches the card it was opened from.
   *
   * Eligibility is decided by the backend now, so no coverage check happens here. Records
   * saved before the detail columns existed cannot fill the breakdown, so those fall back to
   * the previous live calculation path.
   */
  private loadStoredGrade(source: 'try-now' | 'actions-dropdown'): void {
    const currentUuid = this.uuid;

    // Coverage was already checked when the grade was calculated, so this path skips the sales
    // volume verification stage. Marking it complete keeps that loader from showing alongside
    // the report loader, which is the only thing the analyst is actually waiting on here.
    this.dataValidation = true;
    this.loadingdataValidation = 100;
    this.isAnalyticsLoading = true;

    // The header block is store metadata rather than grade data, so it still comes from the
    // store details endpoint whichever path fills the breakdown below it.
    this.loadAssetReviewStoreDetails(false);

    this.assetReviewService.getStoreGrade(this.uuid)
      .pipe(takeUntil(this.analyticsDestroy$))
      .subscribe({
        next: (response: StoreGradeResponse) => {
          if (this.uuid !== currentUuid) {
            return;
          }
          const record = response && response.hasGrade ? response.current : null;
          if (record && record.hasDetail) {
            this.applyGradeRecord(record);
          } else {
            this.fallBackToLiveCalculation(source);
          }
        },
        error: () => {
          if (this.uuid === currentUuid) {
            this.fallBackToLiveCalculation(source);
          }
        }
      });
  }

  /**
   * Hands back to the original live calculation flow, which owns the coverage check and its
   * own loader sequence, so the validation flags are returned to their starting values first.
   */
  private fallBackToLiveCalculation(source: 'try-now' | 'actions-dropdown'): void {
    this.dataValidation = false;
    this.loadingdataValidation = 0;
    this.isAnalyticsLoading = false;
    this.loadshapeData(source);
  }

  private applyGradeRecord(record: StoreGradeRecord): void {
    this.gradeRecord = record;

    const inputs = toAnalyticsPanelInputs(record);
    this.storePerformanceData = inputs.storePerformanceData;
    // This panel binds the real estate block through assetReviewRealEstateQuality.
    this.assetReviewRealEstateQuality = inputs.realEstateQualityData;
    this.bannerStrengthData = inputs.bannerStrengthData;
    this.competitiveImpactData = inputs.competitiveImpactData;
    this.gradeBreakdownData = inputs.gradeBreakdownData;

    if (this.analyticsData) {
      this.analyticsData.overallGrade = record.overall?.grade || 'N/A';
    }

    this.stampRecordReportDate();

    // Reading a stored record, so there is nothing to wait for.
    this.dataValidation = true;
    this.isAnalyticsLoading = false;
    this.isAnalyticsDataLoading = false;
    this.analyticsLoadingProgress = 100;
    this.loadingdataValidation = 100;
  }

  /**
   * The store details endpoint reports today's date, which is right for a live calculation but
   * wrong for a stored one. Viewing an April record under a header dated today is exactly the
   * mismatch this work exists to remove, so the record's own date wins.
   *
   * Called from both here and the store details response, since either can arrive last.
   */
  private stampRecordReportDate(): void {
    const calculatedAt = this.gradeRecord?.calculatedAt;
    if (!calculatedAt || !this.assetReviewStoreDetails) {
      return;
    }
    this.assetReviewStoreDetails = {
      ...this.assetReviewStoreDetails,
      reportDate: new Date(calculatedAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    };
  }

  /**
   * Opens the full breakdown on the record the analyst is looking at on the card.
   *
   * The card owns record selection, so whatever it has active, current, history or an unsaved
   * preview, is what the breakdown shows. It is passed straight through rather than refetched,
   * which is how a preview reaches the breakdown at all, since it was never stored.
   */
  handleViewFullBreakdown(record: StoreGradeRecord): void {
    if (!record) {
      return;
    }

    // Flipping assetReview destroys the grade card with the rest of the panel body, so tell the
    // view state this is a breakdown round trip: the back arrow has to bring the card back with
    // its unsaved preview and history selection intact.
    this.gradeViewState.markBreakdownOpen();

    this.analyticsActiveChange.emit(true);
    this.assetReview = true;
    this.hasAnalyticsError = false;

    this.loadAssetReviewStoreDetails(false);
    this.applyGradeRecord(record);
  }

  handleAssetReviewClose() {
    // Go back action - close analytics panel
    if (this.isExpandedView) this.expandRequested.emit();
    this.isExpandedView = false;
    this.assetReview = false;
    this.analyticsActiveChange.emit(false);

    // Cancel any ongoing analytics API calls
    this.analyticsDestroy$.next();
    this.analyticsDestroy$.complete();
    this.analyticsDestroy$ = new Subject<void>();
  }

  handleRetryAnalytics() {
    // Retry failed APIs while maintaining successful ones
    this.retryFailedApis();
  }

  handleDownloadPdf(): void {
    // Handle PDF download logic here
    console.log('Download PDF requested');
  }

  handleExportData(format: string): void {
    // Handle data export logic here
    console.log('Export data requested in format:', format);
  }

  handleAnalyticsExpand(): void {
    // Handle analytics panel expand logic here - integrate with existing expand
    this.handleExpand();
    console.log('Analytics panel expand requested');
  }

  handleOpenExternal(): void {
    // Carry whichever record is on screen, otherwise the page opens on the current grade and
    // silently disagrees with the breakdown it was opened from.
    const queryParams: { [key: string]: string } = {};
    const record = this.gradeRecord;

    if (record) {
      if (record.recordId !== null && record.recordId !== undefined) {
        queryParams['recordId'] = String(record.recordId);
      } else {
        // A preview has no id because it was never stored, so the page asks for a fresh
        // calculation of its own. That is what the analyst wanted to see anyway, and it keeps
        // the url the single source of truth: reloading or sharing it still works.
        queryParams['refresh'] = 'true';
      }
    }

    // Navigate to analytics full page view
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/detail/asset-review', this.store.uuid], { queryParams })
    );
    const fullUrl = `${window.location.origin}${url}`;
    window.open(fullUrl, '_blank');
  }

  private loadAnalyticsData(): void {
    // Cancel any previous analytics loading
    this.analyticsDestroy$.next();
    this.analyticsDestroy$.complete();
    this.analyticsDestroy$ = new Subject<void>();

    // Reset all error and loading states for new store
    this.isAnalyticsLoading = true;
    this.isAnalyticsDataLoading = true;
    this.analyticsLoadingProgress = 0;
    this.analyticsApiCount = 0;
    this.hasAnalyticsError = false;

    // Reset API states for new store
    this.apiCompletionStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };
    this.apiFailureStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };

    // Clear previous store data to prevent contamination
    this.assetReviewStoreDetails = {};
    this.assetReviewRealEstateQuality = {};
    this.bannerStrengthData = {};
    this.competitiveImpactData = {};
    this.storePerformanceData = null;
    this.analyticsData.overallGrade = null;
    console.log("🚀 ~ StoreSpotlightPanelComponent ~ loadAnalyticsData ~  this.analyticsData.overallGrade:",  this.analyticsData.overallGrade)

    // Load all analytics APIs (use cache if available)
    this.loadAssetReviewStoreDetails(false);
    this.loadAssetReviewRealEstateQuality(false);
    this.loadBannerStrength(false);
    this.loadStorePerformance(false);
    this.loadCompetitiveImpact(false);
  }

  private retryFailedApis(): void {
    // Cancel current analytics operations
    this.analyticsDestroy$.next();
    this.analyticsDestroy$.complete();
    this.analyticsDestroy$ = new Subject<void>();

    // Reset all completion status to prevent using stale data
    this.apiCompletionStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };

    // Clear all data to prevent contamination
    this.assetReviewStoreDetails = {};
    this.assetReviewRealEstateQuality = {};
    this.bannerStrengthData = {};
    this.competitiveImpactData = {};
    this.storePerformanceData = null;
    this.analyticsData.overallGrade = null;
    console.log("🚀 ~ StoreSpotlightPanelComponent ~ retryFailedApis ~  this.analyticsData.overallGrade:",  this.analyticsData.overallGrade)

    // Reset failure status and start fresh
    this.apiFailureStatus = {
      storeDetails: false,
      realEstate: false,
      bannerStrength: false,
      storePerformance: false,
      competitiveImpact: false,
      finalGrade: false
    };

    this.hasAnalyticsError = false;
    this.isAnalyticsLoading = true;
    this.isAnalyticsDataLoading = true;
    this.analyticsLoadingProgress = 0;

    // Load all APIs fresh (force refresh on retry)
    this.loadAssetReviewStoreDetails(true);
    this.loadAssetReviewRealEstateQuality(true);
    this.loadBannerStrength(true);
    this.loadStorePerformance(true);
    this.loadCompetitiveImpact(true);
  }

  private loadAssetReviewStoreDetails(forceRefresh: boolean = false): void {
    this.assetReviewService.assetReviewStoreDetails(this.uuid, forceRefresh)
      .pipe(
        takeUntil(this.analyticsDestroy$),
        catchError(error => {
          console.error('Error loading store details:', error);
          this.hasAnalyticsError = true;
          this.apiFailureStatus.storeDetails = true;
          return of(null);
        })
      )
      .subscribe(result => {
        console.log("🚀 ~ StoreSpotlightPanelComponent ~ loadAssetReviewStoreDetails ~ result:", result)
        if (result) {
          this.assetReviewStoreDetails = result;
          this.stampRecordReportDate();
        }
        this.apiCompletionStatus.storeDetails = true;
        this.updateAnalyticsProgress();
      });
  }

  private loadAssetReviewRealEstateQuality(forceRefresh: boolean = false): void {
    this.assetReviewService.assetReviewRealEstateQuality(this.uuid, forceRefresh)
      .pipe(
        takeUntil(this.analyticsDestroy$),
        catchError(error => {
          console.error('Error loading real estate quality:', error);
          this.hasAnalyticsError = true;
          this.apiFailureStatus.realEstate = true;
          return of(null);
        })
      )
      .subscribe(result => {
        if (result) {
          this.assetReviewRealEstateQuality = {
            accessibility: result?.accessibility,
            parking: result?.parking,
            visibility: result?.visibility,
            trafficFlow: result?.trafficFlow,
            scCondition: result?.scCondition,
            grade: result?.realEstateGrade,
            realEstateScore: result?.realEstateScore || 0
          };
        }
        this.apiCompletionStatus.realEstate = true;
        this.updateAnalyticsProgress();
      });
  }

  private loadBannerStrength(forceRefresh: boolean = false): void {
  if (!this.point || !this.geometry) {
    console.warn('Cannot load banner strength: missing point or geometry.');
    return;
  }

  // Optional: set fips if not already set
  if (!this.fips) {
    console.warn('FIPS is not set. Make sure to provide it.');
  }

  this.assetReviewService
    .assetReviewBannerStrength(this.uuid, this.banneruuid, this.point, this.geometry, forceRefresh)
    .pipe(
      takeUntil(this.analyticsDestroy$),
      catchError(error => {
        console.error('Error loading banner strength:', error);
        this.hasAnalyticsError = true;
        this.apiFailureStatus.bannerStrength = true;
        return of(null);
      })
    )
    .subscribe(result => {
      if (result) {
        this.bannerStrengthData = {
          creditRating: result.creditRating,
          networkStabillity: result.networkStabillity,
          marketPresence: result.marketPresence,
          grade: result.bannerStrengthGrade || 'N/A',
          bannerStrengthScore: result.bannerStrengthScore || 0
        };
      }
      this.apiCompletionStatus.bannerStrength = true;
      this.updateAnalyticsProgress();
    });
}


  private loadStorePerformance(forceRefresh: boolean = false): void {
    // Prepare the request data for store performance
    const storePerformanceRequest = {
      point: {
        lat: this.point.coordinates[1],
        lng: this.point.coordinates[0]
      },
      travelTimeMinutes: 7, // You may want to make this configurable
      locationUuid: null, // Set this if you have a specific location UUID
      comparisonType: "BANNER",
      bannerUuid: this.banneruuid,
      fips: this.fips,
      fit: this.assetReviewStoreDetails.fit
    };
    console.log("---------------fips = ", this.fips);

    this.assetReviewService.assetReviewStorePerformance(this.uuid, storePerformanceRequest, forceRefresh)
      .pipe(
        takeUntil(this.analyticsDestroy$),
        catchError(error => {
          console.error('Error loading store performance:', error);
          this.hasAnalyticsError = true;
          this.apiFailureStatus.storePerformance = true;
          return of(null);
        })
      )
      .subscribe(result => {
        console.log("🚀 ~ StoreSpotlightPanelComponent ~ loadStorePerformance ~ result:", result)
        if (result) {
          // Map the response to your component properties based on actual response structure
          this.storePerformanceData = {
            salesTotalPerformance: {
              vsTradeAreaSalesAverage: result.salesTotalPerformance?.vsTradeAreaSalesAverage,
              vsBannerMarketSalesAverage: result.salesTotalPerformance?.vsBannerMarketSalesAverage,
              vsMarketSalesAverage: result.salesTotalPerformance?.vsMarketSalesAverage,
              annualSalesTotal: result.salesTotalPerformance?.annualSalesTotal,
              salesTotalGrade: result.salesTotalPerformance?.salesTotalGrade || 'N/A',
              salesIndexScore: result.salesTotalPerformance?.salesIndexScore || 0
            },
            salesPerSqftPerformance: {
              vsTradeAreaSalesPerSqftAverage: result.salesPerSqftPerformance?.vsTradeAreaSalesPerSqftAverage,
              vsBannerMarketSalesPerSqftAverage: result.salesPerSqftPerformance?.vsBannerMarketSalesPerSqftAverage,
              vsMarketSalesPerSqftAverage: result.salesPerSqftPerformance?.vsMarketSalesPerSqftAverage,
              annualSalesPerSqft: result.salesPerSqftPerformance?.annualSalesPerSqft,
              salesPerSqftGrade: result.salesPerSqftPerformance?.salesPerSqftGrade || 'N/A',
              salesPerSqftIndexScore: result.salesPerSqftPerformance?.salesPerSqftIndexScore || 0
            },
            driveTimeMinutes : result?.driveTimeMinutes
          };
          console.log("🚀 ~ StoreSpotlightPanelComponent ~ loadStorePerformance ~ this.storePerformanceData:", this.storePerformanceData)
        }
        this.apiCompletionStatus.storePerformance = true;
        this.updateAnalyticsProgress();
      });
  }
simulateProgress(target: number, duration: number) {
  if (this.progressInterval) {
    clearInterval(this.progressInterval);
  }

  const stepTime = 100; // ms
  const step = (target - this.loadingdataValidation) / (duration / stepTime);

  this.progressInterval = setInterval(() => {
    this.loadingdataValidation += step;

    // Stop if we reach 100 or pass the target
    if (this.loadingdataValidation >= target || this.loadingdataValidation >= 100) {
      this.loadingdataValidation = Math.min(this.loadingdataValidation, 100);
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  }, stepTime);
}

  loadshapeData(source: 'try-now' | 'actions-dropdown') {
  this.isAnalyticsLoading = false;
  this.isAnalyticsDataLoading = true;
  this.loadingdataValidation = 0;
  this.dataValidation = false;
  this.simulateProgress(95, 4000);

  const request: SearchIntersectingShapeRequest = {
    latitude: this.point.coordinates[1],
    longitude: this.point.coordinates[0],
    type: SpatialShapeType.CBSA
  };

  if (!this.assetReviewService.isStoreDetailsCached(this.uuid)) {
          this.loadAssetReviewStoreDetails(true);
        } else {
          this.assetReviewService.assetReviewStoreDetails(this.uuid, false)
            .subscribe(result => {
              if (result) {
                this.assetReviewStoreDetails = result;
                this.apiCompletionStatus.storeDetails = true;
              }
            });
        }

  this.shapeService.searchIntersectingShape(request)
    .pipe(
      takeUntil(this.analyticsDestroy$),
      switchMap(intersectingShape => {
        // 🧠 CASE 1: API returned null or undefined — stop further calls
        if (!intersectingShape) {
          console.warn('⚠️ ShapeService returned null — skipping validation.');
          this.loadingdataValidation = 100;
          this.dataValidation = false;
          this.isAnalyticsLoading = false;
          this.isAnalyticsDataLoading = false;
          return of(null);
        }



        // 🧠 CASE 2: API returned empty array — proceed but with defaults
        if (intersectingShape?.features?.length > 0) {
          this.fips = intersectingShape.features[0].id;
          this.geometry = intersectingShape.features[0].geometry;
          this.cbsa = intersectingShape.features[0].properties?.name;
          // ✅ Continue user tracking regardless of shape response

        } else {
          console.warn('No intersecting shape found — proceeding with defaults.');
          this.fips = null;
          this.geometry = null;
          this.cbsa = null;
           this.loadingdataValidation = 100;
          this.dataValidation = false;
          this.isAnalyticsLoading = false;
          this.isAnalyticsDataLoading = false;
          // ✅ Continue user tracking regardless of shape response
        const metadata = {
          storeId: this.store?.uuid,
          storeName: this.store?.name,
          cbsa: this.cbsa
        };
        console.log("🚀 ~ metadata:", metadata);

        let actionType = '';
        let actionDescription = '';
        if (source === 'try-now') {
          actionType = USER_TRACKING_ACTIONS.ASSET_REVIEW_BANNER_CLICK;
          actionDescription = USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.ASSET_REVIEW_BANNER_CLICK];
        } else {
          actionType = USER_TRACKING_ACTIONS.ASSET_REVIEW_DROPDOWN_CLICK;
          actionDescription = USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.ASSET_REVIEW_DROPDOWN_CLICK];
        }

        this.hitTrackingService.hitTheUserTracking(
          USER_TRACKING_SOURCES.ASSET_REVIEW,
          metadata,
          actionType,
          actionDescription,
          true
        ).subscribe({
          next: res => console.log(`✅ Tracking success (${source})`, res),
          error: err => console.error(`❌ Tracking failed (${source})`, err)
        });
          return of(null);


        }

        const metadata = {
          storeId: this.store?.uuid,
          storeName: this.store?.name,
          cbsa: this.cbsa
        };
        console.log("🚀 ~ metadata:", metadata);

        let actionType = '';
        let actionDescription = '';
        if (source === 'try-now') {
          actionType = USER_TRACKING_ACTIONS.ASSET_REVIEW_BANNER_CLICK;
          actionDescription = USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.ASSET_REVIEW_BANNER_CLICK];
        } else {
          actionType = USER_TRACKING_ACTIONS.ASSET_REVIEW_DROPDOWN_CLICK;
          actionDescription = USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.ASSET_REVIEW_DROPDOWN_CLICK];
        }

        this.hitTrackingService.hitTheUserTracking(
          USER_TRACKING_SOURCES.ASSET_REVIEW,
          metadata,
          actionType,
          actionDescription,
          true
        ).subscribe({
          next: res => console.log(`✅ Tracking success (${source})`, res),
          error: err => console.error(`❌ Tracking failed (${source})`, err)
        });

        // ✅ Only call validation if shapeService returned a valid response (even empty features)
        const storeDataValidationRequest = {
          point: { lat: this.point.coordinates[1], lng: this.point.coordinates[0] },
          travelTimeMinutes: 7,
          locationUuid: null,
          fips: this.fips // may be null
        };

        console.log("---------------fips = ", this.fips);

        return this.assetReviewService.assetReviewDataValidation(this.uuid, storeDataValidationRequest, false)
          .pipe(
            takeUntil(this.analyticsDestroy$),
            tap(response => {
              this.loadingdataValidation = 100;
              if (response && response.marketAreaCoveragePercentage > 55 && response.tradeAreaCoveragePercentage > 70) {
                this.dataValidation = true;
                this.loadAnalyticsData();
              } else {
                this.dataValidation = false;
                this.isAnalyticsLoading = false;
                this.isAnalyticsDataLoading = false;
              }
            }),
            catchError(error => {
              console.log("🚀 ~ loadshapeData ~ error:", error);
              this.loadingdataValidation = 100;
              this.isAnalyticsLoading = false;
              this.isAnalyticsDataLoading = false;
              this.dataValidation = false;
              return of(null);
            })
          );
      }),
      catchError(error => {
        console.error('Error loading banner strength:', error);
        this.hasAnalyticsError = true;
        this.apiFailureStatus.bannerStrength = true;
        return of(null);
      })
    )
    .subscribe(result => console.log("🚀 ~ result:", result));
}




  private loadCompetitiveImpact(forceRefresh: boolean = false): void {
    if (!this.point?.coordinates?.length) {
      this.apiCompletionStatus.competitiveImpact = true;
      this.updateAnalyticsProgress();
      return;
    }

    const requestBody = {
      point: {
        lat: this.point.coordinates[1],
        lng: this.point.coordinates[0]
      }
    };

    this.assetReviewService.getCompetitiveImpact(this.uuid, requestBody, forceRefresh)
      .pipe(
        takeUntil(this.analyticsDestroy$),
        catchError(error => {
          console.error('Error fetching competitive impact data:', error);
          this.hasAnalyticsError = true;
          this.apiFailureStatus.competitiveImpact = true;
          return of({});
        })
      )
      .subscribe((result: any) => {
        this.competitiveImpactData = result;
        this.apiCompletionStatus.competitiveImpact = true;
        this.updateAnalyticsProgress();
        console.log('🚀 Competitive Impact Data:', this.competitiveImpactData);
      });
  }

  private updateAnalyticsProgress(): void {
    // Count completed APIs based on status
    const completedCount = Object.values(this.apiCompletionStatus).filter(status => status).length;

    // Calculate progress: each API is worth 15%, final 10% for completion
    this.analyticsLoadingProgress = Math.min((completedCount / this.totalAnalyticsApis) * 90, 90);

    console.log(`Analytics Progress: ${completedCount}/${this.totalAnalyticsApis} APIs completed (${this.analyticsLoadingProgress}%)`);

    // Check if first 5 APIs are complete to trigger final grade API
    const firstFiveComplete = this.apiCompletionStatus.storeDetails &&
      this.apiCompletionStatus.realEstate &&
      this.apiCompletionStatus.bannerStrength &&
      this.apiCompletionStatus.storePerformance &&
      this.apiCompletionStatus.competitiveImpact;

    if (firstFiveComplete && !this.apiCompletionStatus.finalGrade && !this.apiFailureStatus.finalGrade) {
      this.loadFinalGrade();
    }

    if (completedCount >= this.totalAnalyticsApis) {
      // Final 10% for completion
      setTimeout(() => {
        this.analyticsLoadingProgress = 100;
        setTimeout(() => {
          this.isAnalyticsLoading = false;
          this.isAnalyticsDataLoading = false;
          this.analyticsData.isLoaded = true;
        }, 300);
      }, 200);
    }
  }

  private loadFinalGrade(): void {
    const currentUuid = this.uuid; // Capture current UUID

    // Validate all required data is for current store before proceeding
    if (!this.validateDataForCurrentStore()) {
      console.log('Data validation failed - not all APIs completed for current store');
      this.apiFailureStatus.finalGrade = true;
      this.hasAnalyticsError = true;
      return;
    }

    // Use score values from API responses directly
    const payload = {
      salesPerSqft: String(this.storePerformanceData?.salesPerSqftPerformance?.salesPerSqftIndexScore || 0),
      totalSales: String(this.storePerformanceData?.salesTotalPerformance?.salesIndexScore || 0),
      realEstateQuality: String(this.assetReviewRealEstateQuality?.realEstateScore || 0),
      bannerStrength: String(this.bannerStrengthData?.bannerStrengthScore || 0),
      competitiveImpact: String(this.competitiveImpactData?.competitiveImpactScore || 0)
    };
    console.log("🚀 ~ StoreSpotlightPanelComponent ~ loadFinalGrade ~ payload:", payload)

    console.log('Final Grade Payload:', payload);

    this.assetReviewService.getFinalGrade(payload, false)
      .pipe(
        takeUntil(this.analyticsDestroy$),
        catchError(error => {
          console.error('Error loading final grade:', error);
          // Only update error state if still on same store
          if (this.uuid === currentUuid) {
            this.hasAnalyticsError = true;
            this.apiFailureStatus.finalGrade = true;
          }
          return of(null);
        })
      )
      .subscribe(result => {
        // Only process result if still on the same store
        if (this.uuid === currentUuid) {
          if (result) {
            this.analyticsData.overallGrade = result.overAllGrade;
            console.log('Final Grade Result:', result.overAllGrade);


          }
          this.apiCompletionStatus.finalGrade = true;
          this.updateAnalyticsProgress();
        }
      });
  }

  private validateDataForCurrentStore(): boolean {
    // Check if all required APIs completed for current store
    return this.apiCompletionStatus.storeDetails &&
      this.apiCompletionStatus.realEstate &&
      this.apiCompletionStatus.bannerStrength &&
      this.apiCompletionStatus.storePerformance &&
      this.apiCompletionStatus.competitiveImpact &&
      this.storePerformanceData &&
      this.assetReviewRealEstateQuality &&
      this.bannerStrengthData &&
      this.competitiveImpactData &&
      this.assetReviewStoreDetails;
  }



  onAuthorizationChange(): void {
  }

  onAuthorizationInit(): void {
    if (!this.uuid) {
      this.uuid = [...this.map.selections][0];
      this.loadStore();
      this.subscribeToMapSelectionChangeEvents();
    }
  }

  handleOtherStoreSelected(store: Store): void {
    this.uuid = store.uuid;
    this.loadStore();
  }

loadStore(): void {
  // Cancel any previous store loading operations
  this.currentStoreLoadDestroy$.next();
  this.currentStoreLoadDestroy$.complete();
  this.currentStoreLoadDestroy$ = new Subject<void>();

  // Cancel any analytics operations for previous store
  this.analyticsDestroy$.next();
  this.analyticsDestroy$.complete();
  this.analyticsDestroy$ = new Subject<void>();

  this.isFutureStore = false;
  this.isExpandedView = false;
  this.assetReview = false;
  console.log("🚀 ~ StoreSpotlightPanelComponent ~ loadStore ~ isFutureStore:")
  this.isHistoricalStore = false;
  this.isLoading = true;
  this.isVisible = true;


  this.salesAreaPercentage = null;
  this.store = null;
  this.space = null;
  this.shoppingCenter = null;
  this.otherStores = [];
  this.uuidc = this.uuid;

  this.storeService.findOne(this.uuid)
    .pipe(
      takeUntil(this.currentStoreLoadDestroy$),
      catchError((err) => {
        console.error(err);
        this.isFailed = true;
        return of(null);
      }),
      finalize(() => setTimeout(() => this.isLoading = false, 500)),
      switchMap((result: Store) => {
        console.log("🚀 ~ StoreSpotlightPanelComponent ~ loadStore ~ result:", result)

        this.store = result;
        this.space = result.space;
        this.banneruuid = result.banner.uuid;
        this.point = result.space.location.point.features[0].geometry;
        this.shoppingCenter = result.space.shoppingCenter;
        const location = this.store?.space?.location;
        const metadata = {
          storeId: this.store?.uuid,
          storeName: this.store?.name,
          addressLine1: location?.addressLine1,
          city: location?.city,
          state: location?.state,
          postalCode: location?.postalCode,
          county: location?.county,
          shoppingCenterName: this.shoppingCenter.name,
          landlord: this.shoppingCenter?.ownerCompany?.name
        };

        if (!this.map.selectionMode) {
          return this.hitTrackingService.hitTheUserTracking(
            USER_TRACKING_SOURCES.MARKER,
            metadata,
            USER_TRACKING_ACTIONS.CLICK_MARKER,
            USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.CLICK_MARKER]
          ).pipe(
             catchError((err) => {
              if (err.status === 200) {
                console.warn("Tracking returned non-JSON but 200 OK → continuing...");
                return of(null);
              }
              return throwError(() => err);
            }),
            switchMap(() => this.processStoreData())
          );
        } else {
          const arr = this.map.selectedFeatures.map((feature: any) => feature.id);
          let meta = null;
          if (this.map.selectionMode !== MapSelectionMode.RING) {
            if (this.map._isSelectAll) {
              meta = { selectionMode: this.map._isSelectAll, stores: arr, count: arr.length }
            } else {
              meta = { selectionMode: this.map.selectionMode, stores: arr, count: arr.length }
            }
          } else {
            meta = { selectionMode: this.map.selectionMode, radius: this.map.ringMiles, stores: arr, count: arr.length }
          }
          return this.hitTrackingService.hitTheUserTracking(
            USER_TRACKING_SOURCES.STORE_MULTI_SELECT_SPOTLIGHT_CARD,
            meta,
            USER_TRACKING_ACTIONS.MULTIPLE_STORE_DETAILS,
            USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.MULTIPLE_STORE_DETAILS]
          ).pipe(
            catchError((err) => {
              if (err.status === 200) {
                console.warn("Tracking returned non-JSON but 200 OK → continuing...");
                return of(null);
              }
              return throwError(() => err);
            }),
            switchMap(() => this.processStoreData())
          );
        }
      })
    )
    .subscribe(() => {
      this.calculateSalesAreaPercentage();
      // this.initializeAnalyticsData();
    });
}


  private processStoreData(): Observable<any> {
    if (this.hasLicense(LicenseType.STANDARD)) {
      this.isHistoricalStore = _.includes(HistoricalStoreStatuses, this.store.getCurrentStatus().getStatusSystemName());
      this.isFutureStore = _.includes(FutureStoreStatuses, this.store.getCurrentStatus().getStatusSystemName());

      const tasks: Observable<any>[] = [];

      /*Load other stores at this location*/
      tasks.push(
        this.spaceService.findOnesStores(this.space.uuid)
          .pipe(
            takeUntil(this.currentStoreLoadDestroy$),
            tap((results: Store[]) => {
              this.otherStores = _.reject(results, (result: Store) => result.uuid === this.store.uuid);
              results.forEach((ele) => {
                this.otherstoreData[ele.uuid] = {
                  name: ele.name,
                  status: ele.currentStatus.type.systemName
                }
              })
            })
          )
      );

      /*Load this store's volumes*/
      tasks.push(
        this.storeService.findOnesBestVolume(this.store.uuid)
          .pipe(
            takeUntil(this.currentStoreLoadDestroy$),
            tap((result: StoreVolume) => this.volume = result)
          )
      );

      return forkJoin(tasks);
    } else {
      this.storeService.fillWithDummyData(this.store, this.licenseType);
      return of(null);
    }
  }

  private calculateSalesAreaPercentage(): void {
    this.salesAreaPercentage = this.store.getSalesAreaPercentage();
  }

  // private initializeAnalyticsData(): void {
  //   this.analyticsData = {
  //     targetName: this.store?.name || null,
  //     address: this.getFormattedAddress(),
  //     tradeArea: null,
  //     reportDate: ` ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`,
  //     overallGrade: null,
  //     totalSalesPerformance: {
  //       grade: null,
  //       vsTradeAreaAverage: null,
  //       vsBannerMarketAverage: null,
  //       vsMarketAverage: null,
  //       annualSales: this.volume?.total ? `${(this.volume.total / 1000000).toFixed(1)}M` : null
  //     },
  //     salesPerSquareFoot: {
  //       grade: null,
  //       vsTradeAreaAverage: null,
  //       vsBannerMarketAverage: null,
  //       vsMarketAverage: null,
  //       annualSales: this.volume?.total ? `${(this.volume.total / 1000000).toFixed(1)}M` : null
  //     },
  //     realEstateQuality: {
  //       grade: null,
  //       access: null,
  //       parking: null,
  //       visibility: null,
  //       trafficFlow: null,
  //       scCondition: null
  //     },
  //     bannerStrength: {
  //       grade: null,
  //       creditScore: null,
  //       networkStability: null,
  //       marketPresence: null
  //     },
  //     competitiveImpact: {
  //       grade: null,
  //       competitors: []
  //     }
  //   };
  //   console.log('this.analyticsData',this.analyticsData)
  // }

  // private getFormattedAddress(): string {
  //   if (!this.space?.location) {
  //     return null;
  //   }

  //   const location = this.space.location;
  //   let address = location.addressLine1 || '';

  //   if (location.addressLine2) {
  //     address += `, ${location.addressLine2}`;
  //   }

  //   if (location.city) {
  //     address += `, ${location.city}`;
  //   }

  //   if (location.state) {
  //     address += `, ${location.state}`;
  //   }

  //   if (location.postalCode) {
  //     address += ` ${location.postalCode}`;
  //   }

  //   return address || null;
  // }

  onOtherStoresAccordionOpened(): void {
    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.OTHER_STORE,
      this.otherstoreData,
      USER_TRACKING_ACTIONS.OPEN,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.OPEN]
    ).pipe(
    ).subscribe();
  }

  private subscribeToMapSelectionChangeEvents(): void {
    this.addSubscription(
      this.map.events
        .pipe(
          filter((event: MapEvent<any>) => event.type === MapEventType.SELECTION_CHANGE),
          takeUntil(this.destroy$)
        )
        .subscribe((event: MapSelectionEvent) => {
          if (event.payload.size === 1) {
            this.NgZone.run(() => {
              this.uuid = [...event.payload][0];
              this.loadStore();
              this.cdr.detectChanges(); // Trigger change detection explicitly
            });
          } else {
            this.NgZone.run(() => {
              this.uuid = null;
              this.cdr.detectChanges();
            });
          }
        })
    );
  }

  closePanel(): void {
    this.isVisible = false; // Hide the panel

    // Cancel all ongoing operations
    this.currentStoreLoadDestroy$.next();
    this.analyticsDestroy$.next();

    this.NgZone.run(() => {
      this.uuid = null;

      // Clear all marker selections
      this.map.clearSelections();

      // Update marker appearance to reflect deselection
      this.map.updateMarkers();

      this.cdr.detectChanges(); // Ensure Angular updates the DOM
    });
  }

  onViewDetailsClicked(store: Store): void {
    const location = this.store?.space?.location;
    const shoppingCenter = this.store?.space?.shoppingCenter;
    const metadata = {
      storeId: this.store.uuid,
      storeName: this.store.name,
      addressLine1: location?.addressLine1,
      city: location?.city,
      state: location?.state,
      postalCode: location?.postalCode,
      county: location?.county,
      shoppingCenterName: shoppingCenter?.name,
      landlord: shoppingCenter?.ownerCompany?.name,
    };

    this.hitTrackingService.hitTheUserTracking(
      USER_TRACKING_SOURCES.VIEW_DETAILS,
      metadata,
      USER_TRACKING_ACTIONS.VIEW_STORE_DETAILS,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.VIEW_STORE_DETAILS],
      true
    ).pipe(
      catchError((err) => { console.warn('Hit tracking failed silently', err); return of(null); })
    ).subscribe();

    this.router.navigate(['/detail', 'store', store.uuid]);
  }

  isAssetReviewDisabled(): boolean {
    if (!this.store?.getCurrentStatus()) {
      return true;
    }
    const currentStatus = this.store.getCurrentStatus().getStatusSystemName();
    return currentStatus !== StoreStatusType.OPEN && currentStatus !== StoreStatusType.REMODEL;
  }

  getAssetReviewTooltip(): string {
    if (!this.isAssetReviewDisabled()) {
      return '';
    }
    return 'Asset Review is only available for stores with Open or Remodel status';
  }


}
